import styled from "@emotion/styled";

const OnlyTextTitle = styled.h2`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    font-size: 30px;
    margin-bottom: 30px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    font-size: 42px;
    margin-bottom: 25px;
  }
`;

export default OnlyTextTitle;
